module.exports = __webpack_public_path__ + "img/Card_club_A.ca15606b.svg";